module.exports = __webpack_public_path__ + "Rental-Vehicle.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Rental-Vehicle.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Rental-Vehicle.png
// module chunks = 15